import { createPortal } from 'react-dom'
import { useContext, useCallback } from 'react'
import styled from 'styled-components'
import { t } from 'ttag'
import { useDispatch, useSelector } from 'react-redux'

import { Flex as FlexComponent } from '@h2/components/layout/flex'
import { Box } from '@h2/components/layout/box'
import { Heading } from '@h2/components/typography/heading'
import { Button } from '@h2/components/buttons/button'
import { PB90T } from '@h2/components/colors'
import { vagRundFont } from '@h2/components/mixins'
import { features } from '@h2/components/media'
import { user as getUser } from '@h2/common/selectors/user'
import { openSigninDialog } from '@main/actions/signinOrRegisterDialog'
import { Globals } from '@h2/globals'

import { Panel as PanelComponent } from './panel'

const Panel = styled(PanelComponent)`
  width: 100%;
  position: sticky;
  bottom: ${({ noNavRendered }) => (noNavRendered ? 0 : '52px')};
  margin-top: ${({ noNavRendered }) => (noNavRendered ? 0 : '-45px')};
  z-index: 1000;
  box-sizing: border-box;
  background-clip: content-box;
  border-top: 1px solid ${PB90T};

  h4 {
    font-family: 'vag-rundschrift-d', 'Nunito', Helvetica, Arial, sans-serif;
  }

  button {
    ${vagRundFont};
    font-size: 16px;
    font-weight: 400;
    padding: 4px 15px;
  }

  @media (${features.minWidth.laptop}) {
    display: none;
  }
`
const Flex = styled(FlexComponent)`
  padding: 15px 5px;
`
const FixedCallToAction = () => {
  const dispatch = useDispatch()
  const user = useSelector(getUser)
  const noNavRendered = dynamicValues.requireAuthentication && !user
  const { pathname } = window.location
  const { isNavianceUser, backToNavianceURL } = useContext(Globals)
  const onClickFinished = useCallback(() => {
    window.location.assign(backToNavianceURL || 'https://student.naviance.com/')
  }, [backToNavianceURL])

  if (user || (!isNavianceUser && /signin|register|combine|confirm/.test(pathname))) {
    return null
  }

  return createPortal(
    !isNavianceUser ? (
      <Panel id="mobileLoginFooter" color="black" noNavRendered={noNavRendered}>
        <Flex alignItems="center" justifyContent="space-around">
          <Box>
            <Heading level="4" color="white" transform="uppercase" removeMargins>
              {t`Get started today`}
            </Heading>
          </Box>
          <Box>
            <Button
              display="promo"
              onClick={() => dispatch(openSigninDialog('createAccount'))}>
              {t`Create a free account`}
            </Button>
          </Box>
        </Flex>
      </Panel>
    ) : (
      <Panel id="mobileLoginFooter" color="black" noNavRendered={isNavianceUser}>
        <Flex alignItems="center" justifyContent="space-around">
          <Box>
            <Button display="promo" onClick={onClickFinished}>
              {t`Return to Naviance`}
            </Button>
          </Box>
        </Flex>
      </Panel>
    ),
    document.getElementById('spa-content')
  )
}

export { FixedCallToAction }
